module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADqSURBVEhL5ZPBCcJAEEUj4jUdePBqFanBemxCrMMSRDDagFcL8BTw7CH6d/ZBFkxC2N1bHgwmf2fewgSLedC27f07gM5utMWDaxDa4sHzJyLOd4HWURK5tZXEWS9oVHuqIc5yQSXhxes6yCra0nEyM3vyiUOQp60Fx2S0Kvsv8Dp8OedRhPMm64PzKMJ5k/XBeRThvMnGoG8y+gZ1OGeSMTSwVb3od4Kzas1xHiQ84XcXbFymx7eeD9aQikQPrzcWZFfVU+8ra0pBoo93dztVtlMdFS2J4vFqD1FecBtEedEqaid3v0SzpCh+qJx4+ILa1xQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-paint-sprayer/light/24.png
// module id = 2320
// module chunks = 2